const avisos = angular.module('avisos', [])

avisos.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'admin.avisos',
            url: '/avisos',
            params: { showGlobalLoading: { dynamic: true, value: false } },
            component: 'avisos.avisosComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);